/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from 'react'
import { Modal, QRCode, Skeleton } from 'antd'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import classNames from 'classnames'
import { debounce } from 'lodash-es'
import styles from './OpenVipModal.module.less'
import { api } from '@/helpers/api'
import { commonUtils } from '@/helpers/commonUtils'
import { PayHelper } from '@/helpers/payHelper'
import { userService } from '@/services/userService'
import heroDecorationImage from '@/assets/images/vip-upgrade/pc-mastergo-hero.png'
import featureMedicalImage from '@/assets/svg/desktop/features/medical.svg'
import featureOriginalImage from '@/assets/svg/desktop/features/original.svg'
import featureDesignerImage from '@/assets/svg/desktop/features/designer.svg'
import featureSecureImage from '@/assets/svg/desktop/features/secure.svg'
import benefitCheck from '@/assets/svg/desktop/icons/benefit-check.svg'
import wechatIcon from '@/assets/svg/desktop/icons/wechat-pay.svg'
import CustomerQr from '@/assets/images/customer_wxqr1.png'
import { planList } from './plans'

export interface OpenVipModalProps {
  visible: boolean
  detail?: ServerData.PptData
  payHelper: PayHelper
  title?: string
  onPaySuccess?: (timeType: string) => void
  onClose: () => void
}

interface FeatureItem {
  key: string
  title: string
  subtitle: string
  image: string
}

const mask = observable({
  visible: false,
  loging: true,
})

const featureList: FeatureItem[] = [
  { key: 'medical', title: '专注医疗', subtitle: '全场景覆盖', image: featureMedicalImage },
  { key: 'original', title: '高品质原创', subtitle: '正版授权', image: featureOriginalImage },
  { key: 'designer', title: '专业设计师', subtitle: '每日上新', image: featureDesignerImage },
  { key: 'service', title: '售后保障', subtitle: '放心购买', image: featureSecureImage },
]

const OrderInfo = observer((props: OpenVipModalProps) => {
  const [plan, setPlan] = useState<ServerData.OrderPlan[]>([])
  const [currentPlan, setCurrentPlan] = useState<ServerData.OrderPlan>({} as ServerData.OrderPlan)
  const [index, setCurrentIndex] = useState(0)
  const [chargeChannel] = useState<PostData.CreateOrderData['chargeChannel']>('wx_pub_qr')
  const [order, setOrder] = useState<ServerData.CreateOrderData>({} as ServerData.CreateOrderData)
   const [customQrOpen, setCustomQrOpen] = useState(false)

  const one = useRef({
    id: props.detail?.planId ?? '',
    materialId: props.detail?.id,
    price: props.detail?.planData?.price ?? 0,
    timeType: 'one',
    timeName: '单个购买',
    planName: props.detail?.name ?? '',
    count: 1,
    downloadCount: 1,
    activeTime: 0,
    originPrice: 0,
    priceUnit: '个',
    version: '',
  })

  const createOrder = useCallback(
    debounce((planId: string, payChannel: string, materialId?: number | string) => {
      props.payHelper.closePay()
      setOrder({} as ServerData.CreateOrderData)
      props.payHelper.createPayQrCode({
        planId,
        materialId: materialId !== undefined ? Number(materialId) : undefined,
        chargeChannel: payChannel as PostData.CreateOrderData['chargeChannel'],
        onCreateOrder(data) {
          setOrder(data)
        },
        onPaySuccess() {
          props.onPaySuccess?.(currentPlan.timeType)
          props.onClose()
        },
      })
    }, 100),
    [currentPlan.timeType, props]
  )

  useEffect(() => {
    if (currentPlan.id && chargeChannel) {
      createOrder(currentPlan.id, chargeChannel, currentPlan.materialId)
    }
  }, [chargeChannel, createOrder, currentPlan])

  useEffect(() => {
    if (props.visible) {
      mask.loging = true
      api.order
        .getPlanList()
        .then((res) => {
          const list = res.dataList.sort((a, b) => a.price - b.price)
          if (props.detail?.id) {
            setCurrentPlan(one.current as ServerData.OrderPlan)
            setCurrentIndex(0)
            mask.visible = true
          } else {
            mask.visible = false
            const ind = list.findIndex((item) => item.timeType === 'month') || 0
            setCurrentPlan(list.find((item) => item.timeType === 'month') || list[0])
            setCurrentIndex(ind)
          }
          setPlan(list)
        })
        .finally(() => {
          mask.loging = false
        })
    }
  }, [props.detail?.id, props.visible])

  const benefits = currentPlan.timeType === 'one' ? planList : planList.slice(1, 4)
  const currentBenefits = benefits[index]?.benefits ?? []

  if (mask.loging) {
    return (
      <div className={styles.layout}>
        <div className={styles.planPanel}>
          <div className={styles.featureRow}>
            {featureList.map((item) => (
              <div key={item.key} className={styles.featureCard}>
                <Skeleton.Button active style={{ width: 64, height: 64, borderRadius: 20 }} />
                <Skeleton.Button active style={{ width: 100, height: 18, marginTop: 14 }} />
                <Skeleton.Button active style={{ width: 80, height: 14, marginTop: 8 }} />
              </div>
            ))}
          </div>
          <Skeleton.Button active style={{ width: '100%', height: 180, marginTop: 18 }} />
          <Skeleton.Button active style={{ width: '100%', height: 170, marginTop: 18 }} />
        </div>
        <div className={styles.sidePanel}>
          <Skeleton.Button active style={{ width: '100%', height: 140 }} />
          <Skeleton.Button active style={{ width: '100%', height: 280, marginTop: 16 }} />
        </div>
      </div>
    )
  }

  return (
    <div className={styles.layout}>
      <div className={styles.planPanel}>
        <div className={styles.featureRow}>
          {featureList.map((item) => (
            <article key={item.key} className={styles.featureCard}>
              <div className={styles.featureIconWrap}>
                <img src={item.image} alt='' draggable={false} />
              </div>
              <div className={styles.featureCopy}>
                <strong>{item.title}</strong>
                <span>{item.subtitle}</span>
              </div>
            </article>
          ))}
        </div>
        <h2 className={styles.planPanelTitle}>选择付款方案</h2>
        <div
          className={classNames(styles.planGrid, {
            [styles.withSinglePlan]: Boolean(props.detail?.id),
          })}
        >
          {props.detail?.id && (
            <button
              type='button'
              className={classNames(styles.planCard, styles.single, {
                [styles.active]: currentPlan.id === props.detail?.planId,
              })}
              onClick={() => {
                setCurrentPlan(one.current as ServerData.OrderPlan)
                mask.visible = true
              }}
            >
              <div className={styles.planCardBody}>
                <div className={styles.planHead}>
                  <h3>单个购买</h3>
                </div>
                <div className={styles.planPrice}>
                  <span className={styles.currency}>¥</span>
                  <span className={styles.amount}>
                    {commonUtils.parseCurrency(props.detail.planData?.price ?? 0)}
                  </span>
                  <span className={styles.unit}>/个</span>
                </div>
                <span className={styles.planHint}>高清源文件，永久可用</span>
              </div>
            </button>
          )}
          {plan.map((item, index) => {
            const isSelected = currentPlan.id === item.id
            const planCardClass =
              item.timeType === 'week'
                ? styles.trial7
                : item.timeType === 'month'
                  ? styles.power30
                  : styles.carefree365
            return (
              <button
                key={item.id}
                type='button'
                className={classNames(styles.planCard, planCardClass, {
                  [styles.active]: isSelected,
                })}
                onClick={() => {
                  setCurrentPlan(item)
                  setCurrentIndex(index)
                  mask.visible = false
                }}
              >
                <span
                  className={styles.planTopHint}
                >{`低至¥${commonUtils.parseCurrencylimit(item.originPrice / item.downloadCount)}/个`}</span>
                <div className={styles.planCardBody}>
                  <div className={styles.planHead}>
                    <h3>
                      {item.timeType === 'week'
                        ? '7次体验包'
                        : item.timeType === 'month'
                          ? '30次充能包'
                          : item.timeType === 'year'
                            ? '365次无忧包'
                            : item.timeName}
                    </h3>
                  </div>
                  <div className={styles.planPrice}>
                    <span className={styles.currency}>¥</span>
                    <span className={styles.amount}>{commonUtils.parseCurrency(item.price)}</span>
                  </div>
                  {item.timeType === 'month' ? (
                    <span className={styles.planBottomBadge}>83%医护首选</span>
                  ) : item.timeType === 'year' ? (
                    <span className={styles.planBottomBadge}>科室首选</span>
                  ) : null}
                </div>
              </button>
            )
          })}
        </div>

        <section className={styles.benefitBoard}>
          {/* <div className={styles.benefitHeader}>
            <div className={styles.sectionTitle}>{isSingle ? '免费权益' : '会员权益'}</div>
            <div className={styles.accountInfo}>
              <IconImage width={34} src='IconAvatar' />
              <div className={styles.accountCopy}>
                <span>{userService.userData?.inviteCode || '未登录用户'}</span>
                <IconImage
                  width={8}
                  height={10}
                  src='IconCopy'
                  className={styles.copyIcon}
                  onClick={() => {
                    commonUtils.copyToClipboard(userService.userData?.inviteCode ?? '')
                    uiController.message.success('复制成功')
                  }}
                />
              </div>
            </div>
          </div> */}
          <div className={styles.benefitBoardDivider}></div>
          <p className={styles.benefitTitle}>
            {currentPlan.timeType === 'one' ? '免费权益' : '会员权益'}
          </p>
          <ul className={styles.benefitList}>
            {currentBenefits.map((benefit) => (
              <li key={`${currentPlan.id}-${benefit}`}>
                <span className={styles.benefitCheckIcon} aria-hidden='true'>
                  <img src={benefitCheck} alt='' />
                </span>
                <span className={styles.benefitText}>{benefit}</span>
              </li>
            ))}
          </ul>
          {/* {mask.visible && (
            <div className={styles.benefitMask}>
              <IconImage width={18} height={24} src='IconLock' />
              开通会员解锁全部权益
            </div>
          )} */}
        </section>

        <p className={styles.afterSaleCopy}>
          本产品为虚拟数字商品，购买后即获取下载权限，不支持退款/换货。如遇模板文件损坏、内容缺失等质量问题，请联系售后专人处理。
        </p>
      </div>

      <aside className={styles.sidePanel}>
        <section className={styles.serviceCard}>
          <h3>定制服务</h3>
          <p>调整模板费时费神? 追求更卓越的品质? 定制专家级专属 PPT</p>
          <button type='button' className={styles.serviceAction} onClick={() => setCustomQrOpen(true)}>
            立即定制
          </button>
          <a
            href='/custom-service'
          >
            了解详情
          </a>
        </section>

        <section className={styles.paymentCard}>
          <div className={classNames(styles.paymentRow, styles.paymentRowPrice)}>
            <span className={styles.paymentLabel}>实付价：</span>
            <div className={styles.paymentPrice}>
              <span>¥</span>
              <strong>{commonUtils.parseCurrency(currentPlan.price)}</strong>
            </div>
          </div>

          <div className={classNames(styles.paymentRow, styles.paymentRowContent)}>
            <span className={styles.paymentLabel}>内 容：</span>
            <span className={styles.paymentContent}>
              {currentPlan.timeType === 'one'
                ? currentPlan.planName
                : currentPlan.timeType === 'week'
                  ? '7次体验包'
                  : currentPlan.timeType === 'month'
                    ? '30次充能包'
                    : currentPlan.timeType === 'year'
                      ? '365次无忧包'
                      : currentPlan.planName}
            </span>
          </div>

          <div className={styles.qrBox}>
            <QRCode
              value={order.codeUrl || '-'}
              style={{ borderRadius: 0, padding: 0 }}
              size={152}
              bgColor='#fff'
              status={order.codeUrl ? 'active' : 'loading'}
            />
          </div>

          <div className={styles.paymentChannel}>
            <span className={styles.wechatPayIcon}>
              {' '}
              <img src={wechatIcon} />
            </span>
            微信扫码支付
          </div>
        </section>
      </aside>
       {customQrOpen ? (
            <>
              <button
                className={styles.customQrDismiss}
                type="button"
                aria-label="关闭客服二维码"
                onClick={() => setCustomQrOpen(false)}
              />
              <div className={styles.customQrCard} role="dialog" aria-label="扫码添加客服">
                <img src={CustomerQr} alt="客服微信二维码" />
                <span>扫码添加客服</span>
              </div>
            </>
          ) : null}
    </div>
  )
})

const OpenVipModal = observer((props: OpenVipModalProps) => {
  return (
    <Modal
      open={props.visible}
      footer={null}
      closeIcon={false}
      onCancel={props.onClose}
      width={1020}
      centered
      title={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          overflow: 'visible',
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
    >
      <div className={styles.openVipModal}>
        <div className={styles.modalShell} aria-hidden='true' />
        <img
          className={styles.heroDecoration}
          src={heroDecorationImage}
          alt=''
          aria-hidden='true'
          draggable={false}
        />
        <button type='button' className={styles.modalClose} onClick={props.onClose}>
          <span />
          <span />
        </button>
        <div className={styles.modalTitle}>
          {props.title || (userService.isVip ? '续费会员' : '升级会员')}
        </div>
        <OrderInfo {...props} />
      </div>
    </Modal>
  )
})

export default OpenVipModal
